import { action, observable } from "mobx";
import api from "../api";
import { IStudentNote } from "../typings/IStudentNote";
import { IStudentProfile } from "../typings/IStudentProfile";
import { tl } from "../utils";

export default class StudentNotesStore {
  @observable
  rootStore: any;
  @observable
  student: IStudentProfile;
  @observable
  list: Array<IStudentNote>;
  @observable
  loading: boolean;
  @observable
  editing: boolean;
  @observable 
  coursesOfCurrentCurator: { id: number; name: string }[];


  constructor(rootStore: any, student: IStudentProfile) {
    this.rootStore = rootStore;
    this.student = student;
    this.list = [];
  }

  @observable
  async create(text: string, course_id: number, callback: any) {
    this.editing = true;
    try {
      const response = await api.user.addNote(course_id, this.student.id, text);
      this.list.unshift(response);
      this.rootStore.fsNotifierStore.addNotice(
        tl(`Заметка успешно добавлена.`),
        "success"
      );
      this.loading = false;

      callback && callback();
    } catch (error) {
      this.editing = true;
      this.rootStore.fsNotifierStore.addNotice(
        tl(`Произошла ошибка. Заметка не была добавлена.`),
        "error"
      );
    }
  };
  @observable
  async update(noteId: number, text: string, callback: any) {
    this.editing = true;
    try {
      await api.user.updateNote(noteId, text);
      this.rootStore.fsNotifierStore.addNotice(
        tl(`Заметка успешно изменена.`),
        "success"
      );
      this.setNote(noteId, text);
      this.editing = false;

      callback();
    } catch (error) {
      this.editing = false;

      this.rootStore.fsNotifierStore.addNotice(
        tl(`Произошла ошибка. Заметка не была сохранена.`),
        "error"
      );
    }
  };
  @observable
  async getList(): Promise<void> {
    this.loading = true;
    try {
      const response = await api.user.getNotes(this.student.id);
      this.list = [...response.notes];
      this.loading = false;
      this.coursesOfCurrentCurator = response.courses;
    } catch (error) {
      console.log(error);
      this.list = [];
      this.loading = false;
    }
  }

  @action
  async remove (noteId: number) {
    try {
      await api.user.deleteNote(noteId);
      this.rootStore.fsNotifierStore.addNotice(
        tl(`Заметка успешно удалена.`),
        "success"
      );
      this.setNote(noteId, null);
    } catch (error) {
      this.rootStore.fsNotifierStore.addNotice(
        tl(`Произошла ошибка. Заметка не была удалена.`),
        "error"
      );
    }
  };

  @action
  setNote(id: number, text?: string) {
    if (text) {
      const index = this.list.findIndex((item: any) => item.id === id);
      this.list[index].text = text;
    } else this.list = this.list.filter((note: any) => note.id !== id);
  };

}